(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["demo-before-after"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setMainImage(gallery, src) {
      var mainImg = gallery.querySelector('.dba__main-img');
      if (mainImg && src) {
        mainImg.src = src;
      }
    }

    function setActiveThumb(gallery, thumb) {
      var allThumbs = gallery.querySelectorAll('.dba__thumb');
      for (var i = 0; i < allThumbs.length; i++) {
        allThumbs[i].classList.remove('dba__thumb--active');
      }
      thumb.classList.add('dba__thumb--active');
      setMainImage(gallery, thumb.getAttribute('data-thumb-src'));
    }

    function setupThumbSlider(slider) {
      var strip = slider.querySelector('.dba__thumbs');
      var prev = slider.querySelector('.dba__thumbs-nav--prev');
      var next = slider.querySelector('.dba__thumbs-nav--next');
      if (!strip) return;

      function step() {
        return Math.max(strip.clientWidth * 0.8, 120);
      }
      function update() {
        var max = strip.scrollWidth - strip.clientWidth - 1;
        if (prev) prev.classList.toggle('dba__thumbs-nav--disabled', strip.scrollLeft <= 0);
        if (next) next.classList.toggle('dba__thumbs-nav--disabled', strip.scrollLeft >= max);
      }
      if (prev) {
        prev.addEventListener('click', function () {
          strip.scrollBy({ left: -step(), behavior: 'smooth' });
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          strip.scrollBy({ left: step(), behavior: 'smooth' });
        });
      }
      strip.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }

    function activateGallery(gallery, idx) {
      var phone = gallery.getAttribute('data-phone');
      var swatches = gallery.querySelectorAll('.dba__swatch');
      var thumbContainer = gallery.querySelector('[data-thumbs]');

      /* Update active swatch */
      for (var i = 0; i < swatches.length; i++) {
        swatches[i].classList.remove('dba__swatch--active');
        if (parseInt(swatches[i].getAttribute('data-swatch'), 10) === idx) {
          swatches[i].classList.add('dba__swatch--active');
        }
      }

      /* Before phone: all 5 tiles always stay visible (no filtering). Selecting
         color N simply shows image N as the main image and marks that tile
         active (color 1 -> image 1, color 2 -> image 2, color 3 -> image 3). */
      if (phone === 'before') {
        var beforeThumbs = gallery.querySelectorAll('.dba__thumb');
        if (beforeThumbs[idx]) {
          setActiveThumb(gallery, beforeThumbs[idx]);
        }
        return;
      }

      /* After phone: swap thumbnail sets */
      if (thumbContainer) {
        var allThumbs = thumbContainer.querySelectorAll('.dba__thumb');
        for (var i = 0; i < allThumbs.length; i++) {
          var isMatch = allThumbs[i].classList.contains('dba__thumb--s' + idx);
          if (isMatch) {
            allThumbs[i].classList.remove('dba__thumb--hidden');
          } else {
            allThumbs[i].classList.add('dba__thumb--hidden');
          }
        }
      }

      /* Select first visible thumbnail and show it as main */
      var thumbs = gallery.querySelectorAll('.dba__thumb');
      for (var i = 0; i < thumbs.length; i++) {
        thumbs[i].classList.remove('dba__thumb--active');
      }
      for (var i = 0; i < thumbs.length; i++) {
        if (!thumbs[i].classList.contains('dba__thumb--hidden')) {
          thumbs[i].classList.add('dba__thumb--active');
          setMainImage(gallery, thumbs[i].getAttribute('data-thumb-src'));
          break;
        }
      }
    }

    function init() {
      var galleries = document.querySelectorAll('.dba__gallery');

      for (var g = 0; g < galleries.length; g++) {
        (function (gallery) {
          /* Swatch clicks - sync both phones */
          var swatches = gallery.querySelectorAll('.dba__swatch');
          for (var s = 0; s < swatches.length; s++) {
            swatches[s].addEventListener('click', function () {
              var idx = parseInt(this.getAttribute('data-swatch'), 10);
              for (var i = 0; i < galleries.length; i++) {
                activateGallery(galleries[i], idx);
              }
            });
          }

          /* Thumbnail clicks - show clicked thumb as main */
          var thumbs = gallery.querySelectorAll('.dba__thumb');
          for (var t = 0; t < thumbs.length; t++) {
            thumbs[t].addEventListener('click', function () {
              setActiveThumb(gallery, this);
            });
          }
        })(galleries[g]);
      }

      var sliders = document.querySelectorAll('.dba__thumbs-slider');
      for (var k = 0; k < sliders.length; k++) {
        setupThumbSlider(sliders[k]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["demo-brand-marquee"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(bm) {
      var resumeTimer;
      function pause() {
        bm.classList.add('is-paused');
        clearTimeout(resumeTimer);
        resumeTimer = setTimeout(function () {
          bm.classList.remove('is-paused');
        }, 1200);
      }
      /* Stop the auto-scroll while the visitor scrolls or swipes over it */
      bm.addEventListener('wheel', pause, { passive: true });
      bm.addEventListener('touchmove', pause, { passive: true });
    }

    function init() {
      document.querySelectorAll('[data-bm]').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["demo-faq"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-dfaq-list]').forEach(function (list) {
    var cards = list.querySelectorAll('.dfaq__card');

    cards.forEach(function (card) {
      var summary = card.querySelector('.dfaq__question');
      if (!summary) return;

      summary.addEventListener('click', function (event) {
        // Always keep one card open: block closing the currently open card.
        if (card.hasAttribute('open')) {
          event.preventDefault();
          return;
        }

        // Opening this card: close the others so exactly one stays open.
        event.preventDefault();
        cards.forEach(function (other) {
          if (other !== card) other.removeAttribute('open');
        });
        card.setAttribute('open', '');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["demo-featured-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function dfpInit() {

      /* ===== Gallery: thumbnail navigation + main image swap ===== */
      document.querySelectorAll('[id^="dfp-gallery-"]').forEach(function (gallery) {
        var thumbsEl    = gallery.querySelector('.dfp__thumbs');
        var viewportEl  = gallery.querySelector('.dfp__thumbs-viewport');
        var prevBtn     = gallery.querySelector('.dfp__thumbs-nav--prev');
        var nextBtn     = gallery.querySelector('.dfp__thumbs-nav--next');
        var thumbs      = gallery.querySelectorAll('.dfp__thumb');

        var ROW_H    = 90 + 6; /* thumb height + gap */
        var scrollPos = 0;

        function visibleRows() {
          var h = viewportEl ? viewportEl.clientHeight : (thumbsEl ? thumbsEl.clientHeight : 0);
          return h > 0 ? Math.floor(h / ROW_H) : 3;
        }

        function totalRows() {
          return Math.ceil(thumbs.length / 2);
        }

        function maxScroll() {
          return Math.max(0, totalRows() - visibleRows());
        }

        function applyScroll() {
          if (!thumbsEl) return;
          thumbsEl.style.transform = 'translateY(-' + (scrollPos * ROW_H) + 'px)';
          if (prevBtn) prevBtn.disabled = scrollPos <= 0;
          if (nextBtn) nextBtn.disabled = scrollPos >= maxScroll();
        }

        if (prevBtn) {
          prevBtn.addEventListener('click', function () {
            scrollPos = Math.max(0, scrollPos - visibleRows());
            applyScroll();
          });
        }

        if (nextBtn) {
          nextBtn.addEventListener('click', function () {
            scrollPos = Math.min(maxScroll(), scrollPos + visibleRows());
            applyScroll();
          });
        }

        /* Init after layout paint so clientHeight is available */
        setTimeout(applyScroll, 50);

        /* Thumbnail click → swap main image */
        thumbs.forEach(function (thumb) {
          thumb.addEventListener('click', function () {
            var mainImg = document.getElementById(thumb.dataset.main);
            if (!mainImg || !thumb.dataset.src) return;

            mainImg.style.opacity = '0.25';
            var preload = new Image();
            preload.onload = function () {
              mainImg.src = thumb.dataset.src;
              mainImg.style.opacity = '1';
            };
            preload.src = thumb.dataset.src;
            setTimeout(function () { mainImg.style.opacity = '1'; }, 500);

            thumbs.forEach(function (t) { t.classList.remove('dfp__thumb--on'); });
            thumb.classList.add('dfp__thumb--on');
          });
        });
      });

      /* ===== Quantity buttons ===== */
      document.querySelectorAll('[id^="dfp-qty-"]').forEach(function (qtyEl) {
        var valEl = qtyEl.querySelector('.dfp__qty-val');
        qtyEl.querySelectorAll('.dfp__qty-btn').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var current = parseInt(valEl.textContent, 10) || 1;
            var next = btn.dataset.action === 'plus' ? current + 1 : Math.max(1, current - 1);
            valEl.textContent = next;
          });
        });
      });

      /* ===== Variant selection ===== */
      document.querySelectorAll('[id^="dfp-variants-"]').forEach(function (scriptEl) {
        var sectionId = scriptEl.id.replace('dfp-variants-', '');
        var variants;
        try { variants = JSON.parse(scriptEl.textContent); } catch (e) { return; }

        var infoEl  = document.getElementById('dfp-info-'  + sectionId);
        var priceEl = document.getElementById('dfp-price-' + sectionId);
        var availEl = document.getElementById('dfp-avail-' + sectionId);
        var mainImg = document.getElementById('dfp-main-'  + sectionId);
        var addBtn  = infoEl && infoEl.querySelector('.dfp__add-btn');
        if (!infoEl) return;

        var selectedOpts = {};

        infoEl.querySelectorAll('.dfp__opt-group').forEach(function (group) {
          var idx = parseInt(group.dataset.optionIndex, 10);
          var presel = group.querySelector('.dfp__opt-val--sel, .dfp__opt-swatch--sel');
          if (presel) selectedOpts[idx] = presel.dataset.value;

          group.querySelectorAll('.dfp__opt-val, .dfp__opt-swatch').forEach(function (btn) {
            btn.addEventListener('click', function () {
              group.querySelectorAll('.dfp__opt-val, .dfp__opt-swatch').forEach(function (b) {
                b.classList.remove('dfp__opt-val--sel');
                b.classList.remove('dfp__opt-swatch--sel');
              });
              var selClass = btn.classList.contains('dfp__opt-swatch') ? 'dfp__opt-swatch--sel' : 'dfp__opt-val--sel';
              btn.classList.add(selClass);
              selectedOpts[idx] = btn.dataset.value;

              /* Update the "Option name: <selected>" label */
              var selectedLabel = group.querySelector('.dfp__opt-selected');
              if (selectedLabel) selectedLabel.textContent = btn.dataset.value;

              matchVariant();
            });
          });
        });

        function setMainImage(src) {
          if (!mainImg || !src) return;
          mainImg.style.opacity = '0.25';
          var preload = new Image();
          preload.onload = function () {
            mainImg.src = src;
            mainImg.style.opacity = '1';
            var gallery = document.getElementById('dfp-gallery-' + sectionId);
            if (gallery) {
              gallery.querySelectorAll('.dfp__thumb').forEach(function (t) {
                t.classList.toggle('dfp__thumb--on', t.dataset.src === src);
              });
            }
          };
          preload.src = src;
          setTimeout(function () { mainImg.style.opacity = '1'; }, 600);
        }

        function matchVariant() {
          var numOpts = Object.keys(selectedOpts).length;
          var match = null;
          for (var i = 0; i < variants.length; i++) {
            var v = variants[i];
            var ok = true;
            for (var j = 0; j < numOpts; j++) {
              if (v['option' + (j + 1)] !== selectedOpts[j]) { ok = false; break; }
            }
            if (ok) { match = v; break; }
          }
          if (!match) return;

          /* Price */
          if (priceEl) {
            var cls = (match.compare_at_price && match.compare_at_price > match.price)
              ? 'dfp__price-amount dfp__price-amount--sale'
              : 'dfp__price-amount';
            var html = '<span class="' + cls + '">' + match.price_f + '</span>';
            if (match.compare_at_price && match.compare_at_price > match.price) {
              html += '<span class="dfp__price-compare">' + match.compare_at_price_f + '</span>';
            }
            priceEl.innerHTML = html;
          }

          /* Availability */
          if (availEl) {
            var dotCls  = match.available ? 'dfp__avail-dot dfp__avail-dot--in' : 'dfp__avail-dot dfp__avail-dot--out';
            var label   = match.available ? 'In stock' : 'Out of stock';
            availEl.innerHTML = '<span class="' + dotCls + '"></span><span class="dfp__avail-text">' + label + '</span>';
          }

          /* Add to cart button state */
          if (addBtn) {
            addBtn.classList.toggle('dfp__add-btn--unavail', !match.available);
            addBtn.textContent = match.available ? 'Add to cart' : 'Sold out';
          }

          /* Image */
          if (match.image) setMainImage(match.image);
        }
      });

    } // end dfpInit

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', dfpInit);
    } else {
      dfpInit();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["demo-hero"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var sections = document.querySelectorAll('.demo-hero-wrapper');

    sections.forEach(function(section) {
      var screen = section.querySelector('[id^="demo-screen-"]');
      var afterLayer = section.querySelector('[id^="demo-after-"]');
      var wiper = section.querySelector('[id^="demo-wiper-"]');
      var iphone = section.querySelector('.iphone');

      if (!screen || !afterLayer || !wiper) return;

      var speed = parseFloat(screen.closest('.demo-hero').dataset.speed) || 12;
      var position = 100;
      var direction = -1;
      var isDragging = false;
      var isHovering = false;
      var autoplayPaused = false;
      var resumeTimeout = null;
      var lastTimestamp = null;

      function setPosition(pct) {
        pct = Math.max(0, Math.min(100, pct));
        position = pct;
        afterLayer.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
        wiper.style.left = pct + '%';
      }

      /* Auto-animation */
      function animate(timestamp) {
        if (!lastTimestamp) lastTimestamp = timestamp;
        var delta = timestamp - lastTimestamp;
        lastTimestamp = timestamp;

        if (!isDragging && !isHovering && !autoplayPaused) {
          /* Speed: full sweep in `speed` seconds */
          var step = (100 / (speed * 1000)) * delta;
          position += step * direction;

          if (position >= 100) {
            position = 100;
            direction = -1;
          } else if (position <= 0) {
            position = 0;
            direction = 1;
          }

          setPosition(position);
        }

        requestAnimationFrame(animate);
      }

      requestAnimationFrame(animate);

      /* Manual drag (mouse) */
      function getPercent(e) {
        var rect = screen.getBoundingClientRect();
        return ((e.clientX - rect.left) / rect.width) * 100;
      }

      screen.addEventListener('mousedown', function(e) {
        isDragging = true;
        autoplayPaused = true;
        clearTimeout(resumeTimeout);
        setPosition(getPercent(e));
        e.preventDefault();
      });

      document.addEventListener('mousemove', function(e) {
        if (!isDragging) return;
        setPosition(getPercent(e));
      });

      document.addEventListener('mouseup', function() {
        if (!isDragging) return;
        isDragging = false;
        resumeTimeout = setTimeout(function() {
          autoplayPaused = false;
          direction = position < 50 ? 1 : -1;
        }, 2000);
      });

      /* Manual drag (touch) */
      function getTouchPercent(e) {
        var rect = screen.getBoundingClientRect();
        var touch = e.touches[0];
        return ((touch.clientX - rect.left) / rect.width) * 100;
      }

      screen.addEventListener('touchstart', function(e) {
        isDragging = true;
        autoplayPaused = true;
        clearTimeout(resumeTimeout);
        setPosition(getTouchPercent(e));
      }, { passive: true });

      screen.addEventListener('touchmove', function(e) {
        if (!isDragging) return;
        setPosition(getTouchPercent(e));
      }, { passive: true });

      screen.addEventListener('touchend', function() {
        isDragging = false;
        resumeTimeout = setTimeout(function() {
          autoplayPaused = false;
          direction = position < 50 ? 1 : -1;
        }, 2000);
      });

      /* Pause the auto-sweep while hovering over the phone; resume on leave */
      if (iphone) {
        iphone.addEventListener('mouseenter', function() {
          isHovering = true;
        });
        iphone.addEventListener('mouseleave', function() {
          isHovering = false;
          direction = position < 50 ? 1 : -1;
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["demo-pricing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function dprInit() {
      var sections = document.querySelectorAll('[id^="dpr-"]');

      sections.forEach(function (section) {
        var sid = section.id.replace('dpr-', '');

        var dataEl   = document.getElementById('dpr-data-' + sid);
        var select   = document.getElementById('dpr-select-' + sid);
        var card     = document.getElementById('dpr-card-' + sid);
        var nameEl   = document.getElementById('dpr-plan-name-' + sid);
        var prefixEl = document.getElementById('dpr-prefix-' + sid);
        var priceEl  = document.getElementById('dpr-price-' + sid);
        var periodEl = document.getElementById('dpr-period-' + sid);
        var noteEl   = document.getElementById('dpr-note-' + sid);

        if (!dataEl || !select || !card) return;

        var data;
        try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

        /* Store default state from the DOM so we can restore it */
        var defaultPlanLabel = nameEl  ? nameEl.textContent.trim()  : '';
        var defaultPrefix    = prefixEl ? prefixEl.textContent.trim() : '';
        var defaultPrice     = priceEl  ? priceEl.textContent.trim()  : '';
        var defaultNote      = noteEl   ? noteEl.textContent.trim()   : '';

        var plans = {};
        data.plans.forEach(function (p) { plans[p.id] = p; });

        function isFree(price) {
          var p = (price || '').trim().toLowerCase();
          return p === 'free' || p === '$0' || p === '0';
        }

        function update(planId) {
          card.classList.add('dpr__price-card--switching');

          setTimeout(function () {
            /* Empty value = placeholder - restore default "from" state */
            if (!planId) {
              if (nameEl)   nameEl.textContent  = defaultPlanLabel;
              if (prefixEl) prefixEl.textContent = defaultPrefix;
              if (priceEl)  priceEl.textContent  = defaultPrice;
              if (periodEl) periodEl.innerHTML   = '/&nbsp;month';
              if (noteEl)   noteEl.textContent   = defaultNote;
              card.classList.remove('dpr__price-card--switching');
              return;
            }

            var plan = plans[planId];
            if (!plan) { card.classList.remove('dpr__price-card--switching'); return; }

            if (nameEl)   nameEl.textContent  = plan.label;
            if (prefixEl) prefixEl.textContent = '';
            if (noteEl)   noteEl.textContent  = plan.note;

            if (priceEl) {
              if (isFree(plan.price)) {
                priceEl.textContent = 'Free';
                if (periodEl) periodEl.innerHTML = '<span class="dpr__free-badge">No charge</span>';
              } else {
                priceEl.textContent = plan.price;
                if (periodEl) periodEl.innerHTML = '/&nbsp;month';
              }
            }

            card.classList.remove('dpr__price-card--switching');
          }, 120);
        }

        select.addEventListener('change', function () {
          update(this.value);
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', dprInit);
    } else {
      dprInit();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["demo-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function dtmInit() {
      document.querySelectorAll('[id^="dtm-"]').forEach(function (slider) {
        if (!slider.classList.contains('dtm__slider')) return;

        var sid      = slider.id.replace('dtm-', '');
        var track    = document.getElementById('dtm-track-' + sid);
        var prevBtn  = document.getElementById('dtm-prev-' + sid);
        var nextBtn  = document.getElementById('dtm-next-' + sid);
        var dotsWrap = document.getElementById('dtm-dots-' + sid);

        if (!track) return;

        var slides    = track.querySelectorAll('.dtm__slide');
        var total     = slides.length;
        var perView   = parseInt(slider.dataset.perView) || 3;
        var current   = 0;

        /* Adjust perView based on actual viewport */
        function getPerView() {
          if (window.innerWidth <= 599) return 1;
          if (window.innerWidth <= 899) return 2;
          return perView;
        }

        /* Build dots */
        function buildDots() {
          if (!dotsWrap) return;
          dotsWrap.innerHTML = '';
          var pv    = getPerView();
          var pages = Math.ceil(total / pv);
          for (var i = 0; i < pages; i++) {
            var dot = document.createElement('button');
            dot.className = 'dtm__dot' + (i === 0 ? ' dtm__dot--active' : '');
            dot.setAttribute('aria-label', 'Go to page ' + (i + 1));
            dot.dataset.page = i;
            dot.addEventListener('click', function () {
              goTo(parseInt(this.dataset.page) * getPerView());
            });
            dotsWrap.appendChild(dot);
          }
        }

        /* Equalise card heights within the visible window */
        function equaliseHeights() {
          slides.forEach(function (s) {
            s.querySelector('.dtm__card').style.minHeight = '';
          });
          var pv = getPerView();
          var max = 0;
          slides.forEach(function (s) {
            max = Math.max(max, s.querySelector('.dtm__card').offsetHeight);
          });
          slides.forEach(function (s) {
            s.querySelector('.dtm__card').style.minHeight = max + 'px';
          });
        }

        function goTo(index) {
          var pv    = getPerView();
          var pages = Math.ceil(total / pv);
          current   = Math.max(0, Math.min(index, (pages - 1) * pv));

          /* Calculate slide width including gap */
          var gap       = 20;
          var slideW    = slides[0].offsetWidth + gap;
          track.style.transform = 'translateX(-' + (current * slideW) + 'px)';

          /* Update buttons */
          if (prevBtn) prevBtn.disabled = current <= 0;
          if (nextBtn) nextBtn.disabled = current + pv >= total;

          /* Update dots */
          if (dotsWrap) {
            var page = Math.floor(current / pv);
            dotsWrap.querySelectorAll('.dtm__dot').forEach(function (d, i) {
              d.classList.toggle('dtm__dot--active', i === page);
            });
          }
        }

        if (prevBtn) prevBtn.addEventListener('click', function () {
          goTo(current - getPerView());
        });

        if (nextBtn) nextBtn.addEventListener('click', function () {
          goTo(current + getPerView());
        });

        /* Re-init on resize */
        var resizeTimer;
        window.addEventListener('resize', function () {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(function () {
            buildDots();
            equaliseHeights();
            goTo(0);
          }, 150);
        });

        buildDots();
        equaliseHeights();
        goTo(0);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', dtmInit);
    } else {
      dtmInit();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
